export { default as breakpoints } from './breakpoints'
export { default as colors } from './colors'
export { default as container } from './container'
export { default as palette } from './palette'
export { default as spacing } from './spacing'
export { default as typography } from './typography'

export const WONDERSCHOOL_FAVICON = `https://ucarecdn.com/020dbd3a-129c-454c-9d05-a90b2dd365d6/`

export const WONDERSCHOOL_LOGO =
  'https://ucarecdn.com/c1303c54-e765-4c61-bdc0-3922e768c490/-/format/auto/'

export const WONDERSCHOOL_LOGO_SMALL =
  'https://ucarecdn.com/2f563cc2-ca9d-4668-b693-f8aed0159112/-/resize/19x/-/quality/smart/'
